import {
  LookalikeAudienceTableRowProps,
  AudienceTableCellRendererProps,
  LookalikeAudienceTableRowExtraFunctions,
} from 'types/audiences';
import {
  AudienceRowCellDateCreated,
  AudienceRowCellLookalikeAudience,
  AudienceRowCellPlatform,
  AudienceRowCellLookalikesStatus,
} from '../Layout';
import LookalikeAudienceRowCellActions from '../Layout/LookalikeAudienceRowCell.Actions';

const lookalikeAudiencesRowRenderer = (
  props: AudienceTableCellRendererProps<LookalikeAudienceTableRowProps> &
    LookalikeAudienceTableRowExtraFunctions,
) => {
  const { row, header } = props;

  if (!header) return null;

  if (header === 'lookalikeAudience') return <AudienceRowCellLookalikeAudience {...props} />;

  if (header === 'platform') return <AudienceRowCellPlatform {...props} />;

  if (header === 'displayStatus') return <AudienceRowCellLookalikesStatus {...props} />;

  if (header === 'dateCreated') return <AudienceRowCellDateCreated date={row?.createdAt} />;

  if (header === 'actions') return <LookalikeAudienceRowCellActions {...props} />;

  return null;
};

export default lookalikeAudiencesRowRenderer;
